import { object, string } from "yup";

// No field is required -- nothing should ever block the Submit button on its own, but a filled-in email must still be well-formed. founder_phone has no schema rule: MobileInput validates phone format itself via libphonenumber-js.
export const handoverDetailsSchema = object({
  founder_email: string().notRequired().email("Enter a valid email address"),
});
